module.exports = __webpack_public_path__ + "static/media/home-illustration.71f02b90.png";